import { render } from "./CalendarBodyDate.vue?vue&type=template&id=445e989c&scoped=true"
import script from "./CalendarBodyDate.vue?vue&type=script&lang=ts"
export * from "./CalendarBodyDate.vue?vue&type=script&lang=ts"

import "./CalendarBodyDate.vue?vue&type=style&index=0&id=445e989c&lang=scss&scoped=true"
import "./CalendarBodyDate.vue?vue&type=style&index=1&id=445e989c&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-445e989c"

export default script